// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cRQk","importantInfo":"styles_importantInfo__G14aG"};